import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import assignPedido from '../../../../../utils/assignPedido';
import moment from 'moment';
import { fetchAsignacionDefinitiva, fetchFacturacion,fetchEquiposLogisticaDetalle } from '../../../../../actions';
import { connect } from 'react-redux';
import ErrorUIComponent from '../../../../../utils/ErrorUIComponent';
import { FadeLoader } from 'react-spinners';
import Alert from '../../../../../components/Alert';

const TablaPedidos = props => (
  props.pedidos.map((pedido, index) => (
    <tr key={pedido.numPedidoVeh}>
      <td>
        <div className='checkbox'>
          <label>
            <input
              type='checkbox'
              onClick={() => props.onChangeAsignacion(pedido.numPedidoVeh)}
               checked = {props.checkedAsignacion.indexOf(pedido.numPedidoVeh)>=0}
            />
            <div className='checkbox-skin' />
          </label>
        </div>
      </td>
      <td>{pedido.numPedidoVeh}</td>
      <td>{pedido.numChasis}</td>
      <td>{pedido.anoFabricacionVeh}</td>
      <td>{pedido.desColor}</td>
      <td>{pedido.desSituPedido}</td>
      {props.fdv.codFamiliaVeh==="1"?<td></td>:(
        <td width='200'>

            <DatePicker
            selected={props.fechas[index]}
            className='form-control fSearch-search date-picker'
            dateFormat='DD/MM/YYYY'
            locale='es'
            onChange={e => props.changeDate(e, index)}
            placeholderText='Fecha estimada'
            />


          {
            index === 0 &&
              <div className='checkbox'>
                <label htmlFor='todoFechas'>
                  <input type='checkbox' id='todoFechas' checked={props.todoFechas} onChange={props.toggleCheck} />
                  <div className='checkbox-skin' />Aplicar a todos
                </label>
              </div>
          }
        </td>
      )}

    </tr>
  ))
);

const TablaCliente = props => (
  props.pedidos.map((pedido, index) => (
    <tr key={pedido.numPedidoVeh}>
      <td>
        <div className='checkbox'>
          <label>
            <input type='checkbox' />
            <div className='checkbox-skin' />
          </label>
        </div>
      </td>
      <td>{pedido.numPedidoVeh}</td>
      <td>{pedido.desClie}</td>
      <td>{pedido.desPropietarioVeh}</td>
      <td>{pedido.desUsuarioVeh}</td>
      <td>

          <DatePicker
          selected={props.fechas[index]}
          className='form-control fSearch-search date-picker'
          dateFormat='DD/MM/YYYY'
          locale='es'
          onChange={e => props.changeDate(e, index)}
          placeholderText='Fecha estimada'
        />

        {
            index === 0 &&
              <div className='checkbox'>
                <label htmlFor='todoFechas'>
                  <input type='checkbox' id='todoFechas' checked={props.todoFechas} onChange={props.toggleCheck} />
                  <div className='checkbox-skin' />Aplicar a todos
                </label>
              </div>
          }
      </td>
    </tr>
    ))
);

const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL='0';
const SIN_PAGINACION='N';
const PAGINA='1';
const NUMERO_PAGINAS='10';
const CON_PAGO = '1';
const TIPO_PAGO = 'C';

class ThirdStep extends Component {
  constructor(props) {
    super(props);

    const fechas = [];


    this.state = {
      showPedidos: true,
      todoFechas: false,
      fechas,
      checkedAsignacion:[],
      muestraLoad:'none',
      dataGeneralProforma:{},

    };
  }

  componentDidMount(){
      this.loadPage();
  }



  loadPage=() => {


    let fechas = [];
    this.props.pedidosFinal.forEach((entry,index) => {
      fechas[index]=moment(entry.fechaCompromiso);
    })

    this.props.fetchEquiposLogisticaDetalle(this.props.proforma.numProfVeh, '', '', 0, 0).then((result) => {

        this.setState({
          dataGeneralProforma : result.payload.data.equipoAdicionalLocalList,
          fechas:fechas
        });


    }).catch((error) => {
      console.log(error);
    });

  }




  onChangeAsignacion = (numPedidoVeh) => {
    const { checkedAsignacion } = this.state;

    if(checkedAsignacion.indexOf(numPedidoVeh)>=0){
      this.setState({checkedAsignacion:checkedAsignacion.filter(entry => entry!==numPedidoVeh)})
    }else{
      this.setState({checkedAsignacion:[...checkedAsignacion , numPedidoVeh]})
    }

  }

  showPedidos = () => this.setState({ showPedidos: true })
  showClientes = () => this.setState({ showPedidos: false })

  applyAll = () => {
    const { fechas } = this.state;
    const primeraFecha = fechas[0];
    this.props.pedidosFinal.forEach((pedido, index) => {
      fechas[index] = primeraFecha;
    });
    this.setState({ fechas });
  }

  toggleCheck = () => {
    const { todoFechas } = this.state;
    if (!todoFechas) {
      this.applyAll();
    }
    this.setState({ todoFechas: !todoFechas });
  }

  fnArrayAsignarPedidos(fdvID, pedido, proformaID, vendedor,nurFichaVtaPedido) {


    console.log('logger',{
      numPedidoVeh: pedido.numPedidoVeh,
      codCia: pedido.codCia,
      codProv: pedido.codProv,
      numProfVeh: proformaID,
      codClie: pedido.codClie,
      desClie: pedido.desClie,
      codPropietarioVeh: pedido.codPropietarioVeh,
      desPropietarioVeh: pedido.desPropietarioVeh,
      codUsuarioVeh: pedido.codUsuarioVeh,
      desUsuarioVeh: pedido.desUsuarioVeh,

      vendedor:vendedor,
      nurFichaVtaPedido:nurFichaVtaPedido,
      conPago:CON_PAGO,
      tipoPago:TIPO_PAGO,
      numChasis:pedido.numChasis,
      desMarca:pedido.desMarca
    });

    return {
      numPedidoVeh: pedido.numPedidoVeh,
      codCia: pedido.codCia,
      codProv: pedido.codProv,
      numProfVeh: proformaID,
      codClie: pedido.codClie,
      desClie: pedido.desClie,
      codPropietarioVeh: pedido.codPropietarioVeh,
      desPropietarioVeh: pedido.desPropietarioVeh,
      codUsuarioVeh: pedido.codUsuarioVeh,
      desUsuarioVeh: pedido.desUsuarioVeh,
      fecComproEntrega: this.props.fdv.codFamiliaVeh!=="1"?pedido.fecComproEntrega ? pedido.fecComproEntrega : '':'',
      vendedor:vendedor,
      nurFichaVtaPedido:nurFichaVtaPedido,
      conPago:CON_PAGO,
      tipoPago:TIPO_PAGO,
      numChasis:pedido.numChasis,
      desMarca:pedido.desMarca
    };

  }



  asignar = () => {

   this.props.waitForService();
    const { numFichaVtaVeh, numProfVeh } = this.props.proforma;
    const { vendedor } = this.props.fdv;
    const { checkedAsignacion } = this.state;
    const promises = [];
    const promisesAsigDef = [];
    let arrayObjetosAsignar = [];
    let objSinFechaDeCompromiso = {};

    this.props.pedidosFinal.forEach((pedido, index) => {
      const fecha = {
        fecComproEntrega:  this.state.fechas[index]==='' || this.state.fechas[index]===null?'':moment(this.state.fechas[index]).format('DD/MM/YYYY'),
      };

      console.log('fecComproEntrega'+index,fecha.fecComproEntrega);
      const pedidoTotal = Object.assign(pedido, fecha);
      arrayObjetosAsignar.push(this.fnArrayAsignarPedidos(numFichaVtaVeh, pedidoTotal, numProfVeh, vendedor));

    });

    objSinFechaDeCompromiso = arrayObjetosAsignar.find(entry => entry.fecComproEntrega==='')

    if(objSinFechaDeCompromiso !==undefined && (this.props.fdv.codFamiliaVeh==='3' || this.props.fdv.codFamiliaVeh==='2')){
      this.props.openAlertFacturacion({mensaje:'No se asigno fecha comercial al pedido N°' + objSinFechaDeCompromiso.numPedidoVeh ,estadoTrama:'0'});
      this.props.afterService();
    }else{

      promises.push(assignPedido(numFichaVtaVeh,arrayObjetosAsignar));
      Promise.all(promises)
        .then((response) => {
          response.map(r => this.props.openAlert(r.data));
          let count =0;

          if(checkedAsignacion.length>0 && response[0].data.estadoTrama === "1"){/*Requerimiento 91200 ebarboza 29 03 2021 */
            this.props.fetchFacturacion(numFichaVtaVeh, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL, SIN_PAGINACION, PAGINA, NUMERO_PAGINAS)
            .then(entry => {
              this.props.pedidosFinal.forEach((pedido, index) => {
                  if(checkedAsignacion.indexOf(pedido.numPedidoVeh)>=0){
                          this.props.fetchAsignacionDefinitiva(
                            numFichaVtaVeh,
                            pedido.numPedidoVeh,
                            entry.payload.data.listado.filter(entry => entry.numPedidoVeh===pedido.numPedidoVeh)[0].nurFichaVtaPedido,
                            numProfVeh,
                            pedido.codClie,
                            '',
                            pedido.codCia,
                            pedido.codProv,
                            this.props.fdv.vendedor,
                            pedido.codFilial,
                            pedido.codPropietarioVeh,
                            '',
                            arrayObjetosAsignar.find(entry => entry.numPedidoVeh===pedido.numPedidoVeh).fecComproEntrega

                          ).then(entry =>{
                            count++
                            if(checkedAsignacion.length===count){
                              this.props.traerFacturacion(numFichaVtaVeh);
                              this.props.loadProformas(numFichaVtaVeh);
                              this.props.afterService();
                              this.props.closeModal();

                            }

                          });
                        }
                  });
            })
          }else{
            this.props.traerFacturacion(numFichaVtaVeh);
            this.props.loadProformas(numFichaVtaVeh);
            this.props.afterService();
            this.props.closeModal();
          }
        });

    }




  }

  changeDate = (date, index) => {
    const { fechas, todoFechas } = this.state;
    fechas[index] = date;
    if (index === 0 && todoFechas) {
      this.applyAll();
    } else {
      this.setState({ fechas });
    }
  }

  render() {
    const { pedidosFinal, facturacion, propietario, usuario } = this.props;
    const { showPedidos, fechas, todoFechas } = this.state;
    const pedidoClass = showPedidos ? 'tabs-itemPill active' : 'tabs-itemPill';
    const clienteClass = !showPedidos ? 'tabs-itemPill active' : 'tabs-itemPill';
    return (
      <ErrorUIComponent>
      <div className='fdvAsig-slides-item simpleSlide active'>
        <div className='form-group'>
          <p className='labelInfo'>Confirmación de pedidos asignados</p>
          <p>Verífica que todos los datos de ‘Pedidos’ y ‘Facturación’ ingresados sean correctos. También puedes marcar el check de cada pedido para hacer asignación definitiva.</p>
        </div>
        <div className='clearfix'>
          <div className='pull-right'>
            <ul className='tabs' role='tablist'>
              <li className={pedidoClass} role='presentation' onClick={this.showPedidos}>
                <a className='tabs-itemPill-link'>
                  <i className='tabs-itemPill-icon ion-model-s' />
                  <span className='tabs-itemPill-label'>pedidos</span>
                </a>
              </li>
              <li className={clienteClass} role='presentation' onClick={this.showClientes}>
                <a className='tabs-itemPill-link' role='tab'>
                  <i className='tabs-itemPill-icon ion-person-stalker' />
                  <span className='tabs-itemPill-label'>Cliente</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className='tab-content mt-3'>
          {
            showPedidos ?
              <div className='tab-pane active' id='pedidosAsignar'>
                <div className='tableStickyTable'>
                  <div className='tableWrapper' style={{overflow: 'inherit'}}  >
                    <table className='table table-hover'>
                      <thead className='table-head'>
                        <tr>
                          <th>Asignar</th>
                          <th>N° Pedido</th>
                          <th>N° Chasis</th>
                          <th>Año Fabricación</th>
                          <th>Color</th>
                          <th>Situación</th>
                          <th>F° Entrega comercial</th>
                        </tr>
                      </thead>
                      <tbody>
                        <TablaPedidos
                          pedidos={pedidosFinal}
                          fechas={fechas}
                          changeDate={this.changeDate}
                          todoFechas={todoFechas}
                          toggleCheck={this.toggleCheck}
                          checkedAsignacion={this.state.checkedAsignacion}
                          onChangeAsignacion={this.onChangeAsignacion}
                          fdv = {this.props.fdv}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> :
              <div className='tab-pane active' id='facturacionAsignar'>
                <div className='tableStickyTable'>
                  <div className='tableWrapper'>
                    <table className='table table-hover'>
                      <thead className='table-head'>
                        <tr>
                          <th>Asignar</th>
                          <th>N° Pedido</th>
                          <th>Cliente de facturación</th>
                          <th>Cliente propietario</th>
                          <th>Cliente usuario</th>
                          <th>F° Entrega comercial</th>
                        </tr>
                      </thead>
                      <tbody>
                        <TablaCliente
                          pedidos={pedidosFinal}
                          facturacion={facturacion}
                          propietario={propietario}
                          usuario={usuario}
                          fechas={fechas}
                          changeDate={this.changeDate}
                          todoFechas={todoFechas}
                          toggleCheck={this.toggleCheck}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
          }
        </div>
        <div className='modal-actions'>
          <button className='btn btn-default' onClick={this.props.previousStep}>Anterior</button>
          <button className='btn btn-primary pull-right' onClick={this.asignar}>Aceptar</button>
        </div>

        {
          this.props.facturacion && this.props.facturacion.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar facturacion</p>
            </Alert> : null
        }



      </div>


      </ErrorUIComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    facturacion: state.facturacion
  };
}

export default connect(mapStateToProps,
    { fetchAsignacionDefinitiva, fetchFacturacion, fetchEquiposLogisticaDetalle })(ThirdStep);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Proformas/AsociarPedidos/ThirdStep.js